import { graphql } from "gql";

const TYPING_MUTATION = graphql(`
  mutation Typing($messageThreadId: ID!) {
    typing(messageThreadId: $messageThreadId)
  }
`);

export default TYPING_MUTATION;
